import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { components } from "@/api/schema";

import { userKeys } from "./query-keys";

export type CreateUserValues = components["schemas"]["CreateUserRequest"];
export type CreateUserResponse = components["schemas"]["CreateUserResponse"];

export function useCreateUser() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body: CreateUserValues) => {
      const { data, error } = await apiClient.POST("/v1/admin/users", { body });
      if (error) throw error;
      return data as CreateUserResponse;
    },
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: userKeys.all });
    },
  });
}
